// Real data from AI Revolution Digest Podcast

export const podcastInfo = {
  title: "AI Revolution Digest",
  tagline: "Your Unfair Advantage in the Age of AI",
  description: "The podcast that gives you an unfair advantage in the age of artificial intelligence. Powerful insights from CEOs, innovators, and elite industry leaders.",
  host: "Jeslyn Allison Rancap Jerota",
  youtubeChannel: "https://www.youtube.com/@AIRevolutionDigestPodcast",
  spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
  applePodcastsUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192",
  linkedinNewsletter: "https://www.linkedin.com/newsletters/7106830033050079232/",
  latestEpisodeYoutubeId: "8V6aa82vbOo" // The Real Reason You Can't Find a Job Right Now
};

export const episodes = [
  {
    id: 1,
    title: "The Real Reason You Can't Find a Job Right Now",
    description: "**The recruitment revolution isn't coming—it's already here.** AI-powered applicant tracking systems are reshaping how companies find talent, and the rules of job hunting have fundamentally changed overnight. The stakes? Qualified candidates are being filtered out before human eyes ever see their resumes. This episode unpacks the invisible algorithms determining who gets hired and who gets ignored, and reveals the strategic shifts every professional needs to make to stay competitive in an AI-screened job market.",
    youtubeId: "8V6aa82vbOo",
    coverArt: "https://img.youtube.com/vi/8V6aa82vbOo/maxresdefault.jpg",
    duration: "11:46",
    publishedAt: "2024-11-15",
    categories: ["Career", "AI Tools", "Strategy"],
    spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
    appleUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192"
  },
  {
    id: 2,
    title: "When Cybersecurity Experts Talk About AI, They Say This",
    description: "**The security revolution has a dark side.** As organizations rush to deploy AI-powered defenses, they're inadvertently creating new attack vectors that traditional security models never anticipated. The stakes are staggering: AI systems designed to protect us are becoming the very weapons adversaries exploit. Leading cybersecurity experts reveal why the next generation of breaches won't be stopped by better firewalls—and what organizations must do now to secure their AI infrastructure before it's weaponized against them.",
    youtubeId: "JNpeGmzPIKw",
    coverArt: "https://img.youtube.com/vi/JNpeGmzPIKw/maxresdefault.jpg",
    duration: "40:32",
    publishedAt: "2024-10-15",
    categories: ["Cybersecurity", "Interviews", "AI Safety"],
    spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
    appleUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192"
  },
  {
    id: 3,
    title: "AI Won't Save You If Your Team Doesn't Have This",
    description: "**The implementation revolution separates winners from spectators.** Organizations are pouring billions into AI technology, yet 87% of these initiatives fail to deliver meaningful value. The stakes couldn't be higher: your competitors aren't just adopting AI—they're building the organizational muscle to execute on it. This episode exposes the critical success factor that technical excellence alone can't provide, and why the companies that master it will dominate their industries while others drown in failed pilots and wasted investment.",
    youtubeId: "s-mO26m0NCI",
    coverArt: "https://img.youtube.com/vi/s-mO26m0NCI/maxresdefault.jpg",
    duration: "45:19",
    publishedAt: "2024-10-10",
    categories: ["Leadership", "Strategy", "Team Building"],
    spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
    appleUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192"
  },
  {
    id: 4,
    title: "Innovation doesn't fail because of AI, it fails because of this",
    description: "**The innovation revolution has revealed an uncomfortable pattern.** As AI lowers barriers to building, we're witnessing an unprecedented wave of failures—not from bad technology, but from a systemic blind spot that affects even the most sophisticated teams. The stakes extend beyond individual companies: this pattern threatens to slow the pace of genuine progress just when we need breakthrough innovation most. We examine why brilliant ideas consistently collapse and identify the organizational capability that separates transformative innovation from expensive experiments.",
    youtubeId: "bBsYHaz22tM",
    coverArt: "https://img.youtube.com/vi/bBsYHaz22tM/maxresdefault.jpg",
    duration: "46:35",
    publishedAt: "2024-07-20",
    categories: ["Entrepreneurship", "Innovation", "Interviews"],
    spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
    appleUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192"
  },
  {
    id: 5,
    title: "The Skill Everyone's Getting Wrong About AI (And It's Not Coding)",
    description: "**The talent revolution is rewriting career trajectories.** While millions rush to learn prompt engineering and Python, a quiet shift is determining who becomes indispensable in the AI era and who becomes redundant. The stakes for professionals are existential: the skills that made you valuable yesterday may be obsolete tomorrow, but there's one capability AI can't replicate. This episode identifies the overlooked competency that's creating a new class of high-value professionals and explains how to develop it before the market demands it.",
    youtubeId: "npmTUWS9gTI",
    coverArt: "https://img.youtube.com/vi/npmTUWS9gTI/maxresdefault.jpg",
    duration: "53:58",
    publishedAt: "2024-04-25",
    categories: ["Career", "Skills", "Future of Work"],
    spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
    appleUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192"
  },
  {
    id: 6,
    title: "AI Regulation: The Hidden Cost Nobody's Talking About",
    description: "**The policy revolution is creating unintended casualties.** As governments worldwide race to regulate AI, well-intentioned frameworks are producing outcomes that contradict their stated goals. The stakes transcend individual companies: misaligned regulation could entrench incumbents, stifle competition, and ensure AI's benefits flow only to those who can afford compliance. We analyze the emerging regulatory landscape and its practical implications for organizations trying to innovate responsibly while navigating an uncertain policy environment.",
    youtubeId: "GQwqVofKtwE",
    coverArt: "https://img.youtube.com/vi/GQwqVofKtwE/maxresdefault.jpg",
    duration: "52:04",
    publishedAt: "2024-04-20",
    categories: ["Policy", "Tech News", "Analysis"],
    spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
    appleUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192"
  },
  {
    id: 7,
    title: "Why Your AI Initiative Failed — And What to Do Now",
    description: "**The execution revolution exposes a predictable pattern.** Failed AI projects share remarkably similar trajectories, yet organizations keep repeating the same mistakes with expensive consequences. The stakes are immediate: every quarter spent on a failing initiative is a quarter your competitors use to pull ahead. Through forensic analysis of real implementations, we identify the root causes behind AI project failures and provide a practical framework for course-correction that turns struggling initiatives into strategic advantages.",
    youtubeId: "FpcrGRwJOoE",
    coverArt: "https://img.youtube.com/vi/FpcrGRwJOoE/maxresdefault.jpg",
    duration: "8:15",
    publishedAt: "2024-04-15",
    categories: ["Strategy", "Case Studies", "Leadership"],
    spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
    appleUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192"
  },
  {
    id: 8,
    title: "The AI Healthcare Gap Nobody's Talking About",
    description: "**The healthcare revolution is leaving patients behind.** AI diagnostics now surpass human accuracy, yet most patients never benefit from these breakthroughs. The stakes are measured in lives: every day the gap persists, treatable conditions go undetected and preventable deaths occur. We investigate the systemic barriers preventing AI healthcare innovation from reaching those who need it most, and highlight the practitioners and technologists building bridges between cutting-edge capability and equitable access.",
    youtubeId: "JBQoeZt8KWo",
    coverArt: "https://img.youtube.com/vi/JBQoeZt8KWo/maxresdefault.jpg",
    duration: "40:58",
    publishedAt: "2024-01-15",
    categories: ["Healthcare", "Impact", "Interviews"],
    spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
    appleUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192"
  },
  {
    id: 9,
    title: "The Pattern Behind Every $10M Founder Mistake",
    description: "**The entrepreneurship revolution reveals a psychological trap.** Analysis of major startup failures shows a consistent decision-making pattern that destroys well-funded, well-led companies. The stakes are personal and financial: understanding this pattern could mean the difference between building generational wealth and watching your equity evaporate. We decode the cognitive blind spot that bankrupts even sophisticated founders and present the mental models that help successful entrepreneurs avoid this expensive, repeatable mistake.",
    youtubeId: "4eXtuCSxMYc",
    coverArt: "https://img.youtube.com/vi/4eXtuCSxMYc/maxresdefault.jpg",
    duration: "15:18",
    publishedAt: "2024-01-10",
    categories: ["Entrepreneurship", "Case Studies", "Psychology"],
    spotifyUrl: "https://open.spotify.com/show/36qsvwH3H7sX3PZQOdieit",
    appleUrl: "https://podcasts.apple.com/us/podcast/ai-revolution-digest/id1793143192"
  }
];

// Available categories for filtering
export const categories = [
  "All",
  "AI Tools",
  "Interviews", 
  "Career",
  "Leadership",
  "Strategy",
  "Entrepreneurship",
  "Healthcare",
  "Cybersecurity",
  "Tech News",
  "Future of Work",
  "AI Safety",
  "Policy"
];

export const shorts = [
  {
    id: 1,
    title: "Is AI Friend or Foe? Military Perspective",
    thumbnail: "https://img.youtube.com/vi/sJMOzmzXncc/mqdefault.jpg",
    youtubeId: "sJMOzmzXncc",
    views: "1"
  },
  {
    id: 2,
    title: "She Proved Them Wrong: Military Mom Edition",
    thumbnail: "https://img.youtube.com/vi/3-Vt2bjb-fs/mqdefault.jpg",
    youtubeId: "3-Vt2bjb-fs",
    views: "New"
  },
  {
    id: 3,
    title: "Bringing Them Home: The Only Metric That Matters",
    thumbnail: "https://img.youtube.com/vi/Wkosdm7MPAI/mqdefault.jpg",
    youtubeId: "Wkosdm7MPAI",
    views: "3"
  },
  {
    id: 4,
    title: "The quickest way to build team ownership",
    thumbnail: "https://img.youtube.com/vi/OsZ2GCQRvn4/mqdefault.jpg",
    youtubeId: "OsZ2GCQRvn4",
    views: "New"
  },
  {
    id: 5,
    title: "AI Gives Info, But Humans MUST Understand!",
    thumbnail: "https://img.youtube.com/vi/7_oOKT9c7SA/mqdefault.jpg",
    youtubeId: "7_oOKT9c7SA",
    views: "New"
  },
  {
    id: 6,
    title: "Are We Losing Our Ability to Think?",
    thumbnail: "https://img.youtube.com/vi/OGEnjQcqoJI/mqdefault.jpg",
    youtubeId: "OGEnjQcqoJI",
    views: "2"
  }
];
